import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment.development';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) { }
  pathName = 'api/v1/signature';
  getUrls() {
    return this.http.get(`${environment.baseUrl}/${this.pathName}/urls`)
  }

  getCompanies() {
    return this.http.get(`${environment.baseUrl}/${this.pathName}/companies`)
  }

  getBanners() {
    return this.http.get(`${environment.baseUrl}/${this.pathName}/banners`)
  }

  getBrands() {
    return this.http.get(`${environment.baseUrl}/${this.pathName}/market-brand-logos`)
  }

  getBrandsInfo() {
    return this.http.get(`${environment.baseUrl}/${this.pathName}/brandinfo`)
  }

  getPromotionalbanners() {
    return this.http.get(`${environment.baseUrl}/${this.pathName}/promotional-banners`)
  }

  getEmailSignature(email: string) {
    return this.http.get(`${environment.baseUrl}/${this.pathName}/${email}`)
  }

  setSignature(payload: any) {
    return this.http.post(`${environment.baseUrl}/${this.pathName}/set-signature`, payload);
  }
}
